module.exports = __webpack_public_path__ + "images/the-dealer-505bb3d933873d2deb3e604a6589653a.png";